export default __webpack_public_path__ + "images/loggedout/home/splash_logo-9c77ea211f661df0468b77be79ea2dde.svg";